import React, { useState } from 'react';
import "../../Tablet/PackageDetailPage/PackageDetail.css";
import { Tab, Tabs, TabList, TabPanel } from "../Lib/react-tabs/esm/index";
import "../Lib/react-tabs/style/react-tabs.css";
import {HashLink as Link} from "react-router-hash-link";
import { useParams } from 'react-router-dom';

function App() {
return <X12PackagesDetailPageTablet {...x12PackagesDetailPageTabletData} />;
}

export default App;
 function X12PackagesDetailPageTablet(props) {
  let { categoryid } = useParams();
  let { packageid } = useParams();
  const {
    //tabletHeader,
  
    packages,
    rectangle76,
    basic,
    number,
    rsSft,
    place,
    premium,
    luxury,
    clarityDesignLine,
    designDrawings,
    iconParkOutlineBuildingThree,
    structure,
    biDoorOpen,
    doorFrames,
    mdiWindowShutter,
    doorShutters,
    iconParkOutlineDoorHandle,
    doorFittings,
    tablerWindow,
    window,
    icBaselineGridOn,
    frame,
    frame1683,
    frame1684,
    frame1685,
    bedRoom,
    tv,
    poojaRoom,
    crockery,
    study,
    ceiling,
    shoe,
    flooring,
    kitchenCounter,
    bathroom,
    painting,
    switchesPlates,
    kitchen,
    bedroom,
    tvUnit,
    poojaUnit,
    crockeryUnit,
    studyUnit,
    falseCeiling,
    shoeRack,
    //footerProps,
    group102Props,
    frame692Props,
    frame692Props2,
    frame692Props3,

    // Construction
    //Basic
    frame1686Props,
    frame16862Props,
    frame16863Props,
    frame16864Props,
    frame16865Props,
    frame16866Props,
    frame16867Props,
    frame16868Props,
    frame16869Props,
    frame16870Props,
    frame16871Props,
    //Standard
    frame1786Props,
    frame17862Props,
    frame17863Props,
    frame17864Props,
    frame17865Props,
    frame17866Props,
    frame17867Props,
    frame17868Props,
    frame17869Props,
    frame17870Props,
    frame17871Props,
    //Premium
    frame1886Props,
    frame18862Props,
    frame18863Props,
    frame18864Props,
    frame18865Props,
    frame18866Props,
    frame18867Props,
    frame18868Props,
    frame18869Props,
    frame18870Props,
    frame18871Props,
    //Luxury
    frame1986Props,
    frame19862Props,
    frame19863Props,
    frame19864Props,
    frame19865Props,
    frame19866Props,
    frame19867Props,
    frame19868Props,
    frame19869Props,
    frame19870Props,
    frame19871Props,

    //Interior
    //Basic
    frame2086Props,
    frame20862Props,
    frame20863Props,
    frame20864Props,
    //Standard
    frame2087Props,
    frame20872Props,
    frame20873Props,
    frame20874Props,
    frame20875Props,
    //Premium
     frame2088Props,
     frame20882Props,
     frame20883Props,
     frame20884Props,
     frame20885Props,
     frame20886Props,
     frame20887Props,
     frame20888Props,
    //Luxury
     frame2089Props,
     frame20892Props,
     frame20893Props,
     frame20894Props,
     frame20895Props,
     frame20896Props,
     frame20897Props,
     frame20898Props,
     frame20899Props,
  } = props;

  return (
          <>
            <h1 className="pdp-title pdp-valign-text-middle apd-typographyheadlineh2-extrabold-40">{packages}</h1>
              <img className="pdp-rectangle-76" src={rectangle76} />
              <Tabs defaultIndex={categoryid-1} style={{ marginTop: '0px' , width:"100%"}}>
                <TabList>
                  <Tab style={{ bottom: '0px' }}>
                    <div className="pdp-construction lpd-overpass-extra-bold-shark-14px">CONSTRUCTION</div>
                  </Tab>
                  <Tab style={{ bottom: '0px' }}>
                    <div className="pdp-place-2 lpd-overpass-extra-bold-shark-14px">INTERIOR</div>
                  </Tab>
                </TabList>
                <TabPanel>
                  <Tabs className="tab" defaultIndex={packageid-1} selectedTabClassName="tab-li tab-active">
                    <TabList className="tab-list">
                      <Tab className="tab-li">
                        <div className="pdp-frame-1695">
                          <div className="pdp-basic pdp-valign-text-middle pdp-overpass-extra-bold-white-24px">{basic}</div>
                          <div className="pdp-frame-69">
                            <div className="pdp-number pdp-valign-text-middle pdp-overpass-extra-bold-white-30px">1600</div>
                            <div className="pdp-rs-sft pdp-valign-text-middle pdp-overpass-normal-white-16px">{rsSft}</div>
                          </div>
                          <div id="design-drawing" style={{color:"transparent"}}></div> 
                        </div>
                      </Tab>
                      <Tab className="tab-li">
                        <div className="pdp-frame-1696" >
                          <div className="pdp-place pdp-valign-text-middle pdp-overpass-extra-bold-mine-shaft-24px">{place}</div>
                          <Frame692 number="1700" rsSft={frame692Props.rsSft} />
                        </div>
                      </Tab>
                      <Tab className="tab-li">
                        <div className="pdp-frame-1697">
                          <div className="pdp-premium pdp-valign-text-middle pdp-overpass-extra-bold-mine-shaft-24px">{premium}</div>
                          <Frame692
                            number="1950"
                            rsSft={frame692Props2.rsSft}
                            className={frame692Props2.className}
                          />
                        </div>
                      </Tab>
                      <Tab className="tab-li">
                        <div className="pdp-frame-1698">
                          <div className="pdp-luxury pdp-valign-text-middle pdp-overpass-extra-bold-mine-shaft-24px">{luxury}</div>
                          <Frame692
                            number="2500"
                            rsSft={frame692Props3.rsSft}
                            className={frame692Props3.className}
                          />
                        </div>
                      </Tab>
                    </TabList>
                      <TabPanel className="tab-panel">
                        <div className="pdp-rectangle-107">
                          <div className="pdp-frame-1677">
                            <div className="pdp-frame-1675">
                              <Link smooth to="#design-drawing" >
                                <div className="navigation-text active">
                                  <img className="pdp-claritydesign-line" src={clarityDesignLine} />
                                  <div className="pdp-design-drawings pdp-valign-text-middle text-top">{designDrawings}</div>
                                </div>
                              </Link>
                            </div>
                            <div className="pdp-frame-1676" >
                              <Link smooth to="#structure" >
                                <div className="navigation-text">
                                  <img className="pdp-icon-park-outli-ebuilding-three " src={iconParkOutlineBuildingThree} />
                                  <div className="pdp-structure pdp-valign-text-middle pdp-overpass-extra-bold-black-16px text-top">{structure}</div>
                                </div>
                              </Link>
                            </div>
                            <div className="pdp-frame-1677-1" >
                              <Link smooth to="#door-frames">
                                <div className="navigation-text">
                                  <img className="pdp-bidoor-open " src={biDoorOpen} />
                                  <div className="pdp-door-frames pdp-valign-text-middle pdp-overpass-extra-bold-black-16px text-top">{doorFrames}</div>
                                </div>
                              </Link>
                            </div>
                            <div className="pdp-frame-1678">
                              <Link smooth to="#door-shutters">
                                <div className="navigation-text">
                                  <img className="pdp-mdiwindow-shutter" src={mdiWindowShutter} />
                                  <div className="pdp-door-shutters pdp-valign-text-middle pdp-overpass-extra-bold-black-16px text-top">{doorShutters}</div>
                                </div>
                              </Link>
                            </div>
                            <div className="pdp-frame-1679">
                              <Link smooth to="#door-fittings">
                                <div className="navigation-text">
                                  <img className="pdp-icon-park-outlinedoor-handle" src={iconParkOutlineDoorHandle} />
                                  <div className="pdp-door-fittings pdp-valign-text-middle pdp-overpass-extra-bold-black-16px text-top">{doorFittings}</div>
                                </div>
                              </Link>
                            </div>
                            <div className="pdp-frame-1680">
                              <Link smooth to="#window">
                                <div className="navigation-text">
                                  <img className="pdp-tablerwindow" src={tablerWindow} />
                                  <div className="pdp-window pdp-valign-text-middle pdp-overpass-extra-bold-black-16px text-top">{window}</div>
                                </div>
                              </Link>
                            </div>
                            <div className="pdp-frame-1681">
                              <Link smooth to="#flooring">
                                <div className="navigation-text">
                                  <img className="pdp-icbaseline-grid-on" src={icBaselineGridOn} />
                                  <div className="pdp-flooring pdp-valign-text-middle pdp-overpass-extra-bold-black-16px text-top">{flooring}</div>
                                </div>
                              </Link>
                            </div>
                            <div className="pdp-frame-1681">
                              <Link smooth to="#kitchen-counter">
                                <div className="navigation-text">
                                  <img className="pdp-icbaseline-grid-on" src={frame} />
                                  <div className="pdp-flooring pdp-valign-text-middle pdp-overpass-extra-bold-black-16px text-top">{kitchenCounter}</div>
                                </div>
                              </Link>
                            </div>
                            <div className="pdp-frame-1681">
                              <Link smooth to="#bathroom">
                                <div className="navigation-text">
                                  <img className="pdp-icbaseline-grid-on" src={frame1683} />
                                  <div className="pdp-flooring pdp-valign-text-middle pdp-overpass-extra-bold-black-16px text-top">{bathroom}</div>
                                </div>
                              </Link>
                            </div>
                            <div className="pdp-frame-1681">
                              <Link smooth to="#painting">
                                <div className="navigation-text">
                                  <img className="pdp-icbaseline-grid-on" src={frame1684} />
                                  <div className="pdp-flooring pdp-valign-text-middle pdp-overpass-extra-bold-black-16px text-top">{painting}</div>
                                </div>
                              </Link>
                            </div>
                            <div className="pdp-frame-1681">
                              <Link smooth to="#switches-plates">
                                <div className="navigation-text">
                                  <img className="pdp-icbaseline-grid-on" src={frame1685} />
                                  <div className="pdp-flooring pdp-valign-text-middle pdp-overpass-extra-bold-black-16px text-top">{switchesPlates}</div>
                                </div>
                              </Link>
                            </div>
                          </div>
                          <div className="pdp-frame-1700">
                            <Frame1686 
                              text10={frame1686Props.text10} 
                              text11={frame1686Props.text11} 
                              id={frame16862Props.id} 
                              />
                            <Frame1686
                              text10={frame16862Props.text10}
                              text11={frame16862Props.text11}
                              className={frame16862Props.className}
                              id={frame16863Props.id}
                            />
                            <Frame1686
                              text10={frame16863Props.text10}
                              text11={frame16863Props.text11}
                              className={frame16863Props.className}
                              id={frame16864Props.id}
                            />
                             <Frame1686
                              text10={frame16864Props.text10}
                              text11={frame16864Props.text11}
                              className={frame16864Props.className}
                              id={frame16865Props.id}
                            />
                            <Frame1686
                              text10={frame16865Props.text10}
                              text11={frame16865Props.text11}
                              className={frame16865Props.className}
                              id={frame16866Props.id}
                            />
                            <Frame1686
                              text10={frame16866Props.text10}
                              text11={frame16866Props.text11}
                              className={frame16866Props.className}
                              id={frame16867Props.id}
                            />
                            <Frame1686
                              text10={frame16867Props.text10}
                              text11={frame16867Props.text11}
                              className={frame16867Props.className}
                              id={frame16868Props.id}
                            />
                            <Frame1686
                              text10={frame16868Props.text10}
                              text11={frame16868Props.text11}
                              className={frame16868Props.className}
                              id={frame16869Props.id}
                            />
                            <Frame1686
                              text10={frame16869Props.text10}
                              text11={frame16869Props.text11}
                              className={frame16869Props.className}
                              id={frame16870Props.id}
                            />
                            <Frame1686
                              text10={frame16870Props.text10}
                              text11={frame16870Props.text11}
                              className={frame16870Props.className}
                              id={frame16871Props.id}
                            />
                            <Frame1686
                              text10={frame16871Props.text10}
                              text11={frame16871Props.text11}
                              className={frame16871Props.className}
                              // id={frame16871Props.id}
                            />
                          </div>
                        </div>
                      </TabPanel>
                  <TabPanel className="tab-panel">
                    <div className="pdp-rectangle-107">
                    <div className="pdp-frame-1677">
                      <div className="pdp-frame-1675">
                        <Link smooth to="#design-drawing" >
                          <div className="navigation-text active">
                            <img className="pdp-claritydesign-line " src={clarityDesignLine} />
                            <div className="pdp-design-drawings pdp-valign-text-middle text-top">{designDrawings}</div>
                          </div>
                        </Link>
                      </div>
                      <div className="pdp-frame-1676" >
                        <Link smooth to="#structure" >
                          <div className="navigation-text">
                            <img className="pdp-icon-park-outli-ebuilding-three " src={iconParkOutlineBuildingThree} />
                            <div className="pdp-structure pdp-valign-text-middle pdp-overpass-extra-bold-black-16px text-top">{structure}</div>
                          </div>
                        </Link>
                      </div>
                      <div className="pdp-frame-1677-1" >
                        <Link smooth to="#door-frames">
                          <div className="navigation-text">
                            <img className="pdp-bidoor-open " src={biDoorOpen} />
                            <div className="pdp-door-frames pdp-valign-text-middle pdp-overpass-extra-bold-black-16px text-top">{doorFrames}</div>
                          </div>
                        </Link>
                      </div>
                      <div className="pdp-frame-1678">
                        <Link smooth to="#door-shutters">
                          <div className="navigation-text">
                            <img className="pdp-mdiwindow-shutter" src={mdiWindowShutter} />
                            <div className="pdp-door-shutters pdp-valign-text-middle pdp-overpass-extra-bold-black-16px text-top">{doorShutters}</div>
                          </div>
                        </Link>
                      </div>
                      <div className="pdp-frame-1679">
                        <Link smooth to="#door-fittings">
                          <div className="navigation-text">
                            <img className="pdp-icon-park-outlinedoor-handle" src={iconParkOutlineDoorHandle} />
                            <div className="pdp-door-fittings pdp-valign-text-middle pdp-overpass-extra-bold-black-16px text-top">{doorFittings}</div>
                          </div>
                        </Link>
                      </div>
                      <div className="pdp-frame-1680">
                        <Link smooth to="#window">
                          <div className="navigation-text">
                            <img className="pdp-tablerwindow" src={tablerWindow} />
                            <div className="pdp-window pdp-valign-text-middle pdp-overpass-extra-bold-black-16px text-top">{window}</div>
                          </div>
                        </Link>
                      </div>
                      <div className="pdp-frame-1681">
                        <Link smooth to="#flooring">
                          <div className="navigation-text">
                            <img className="pdp-icbaseline-grid-on" src={icBaselineGridOn} />
                            <div className="pdp-flooring pdp-valign-text-middle pdp-overpass-extra-bold-black-16px text-top">{flooring}</div>
                          </div>
                        </Link>
                      </div>
                      <div className="pdp-frame-1681">
                        <Link smooth to="#kitchen-counter">
                          <div className="navigation-text">
                            <img className="pdp-icbaseline-grid-on" src={frame} />
                            <div className="pdp-flooring pdp-valign-text-middle pdp-overpass-extra-bold-black-16px text-top">{kitchenCounter}</div>
                          </div>
                        </Link>
                      </div>
                      <div className="pdp-frame-1681">
                        <Link smooth to="#bathroom">
                          <div className="navigation-text">
                            <img className="pdp-icbaseline-grid-on" src={frame1683} />
                            <div className="pdp-flooring pdp-valign-text-middle pdp-overpass-extra-bold-black-16px text-top">{bathroom}</div>
                          </div>
                        </Link>
                      </div>
                      <div className="pdp-frame-1681">
                        <Link smooth to="#painting">
                          <div className="navigation-text">
                            <img className="pdp-icbaseline-grid-on" src={frame1684} />
                            <div className="pdp-flooring pdp-valign-text-middle pdp-overpass-extra-bold-black-16px text-top">{painting}</div>
                          </div>
                        </Link>
                      </div>
                      <div className="pdp-frame-1681">
                        <Link smooth to="#switches-plates">
                          <div className="navigation-text">
                            <img className="pdp-icbaseline-grid-on" src={frame1685} />
                            <div className="pdp-flooring pdp-valign-text-middle pdp-overpass-extra-bold-black-16px text-top">{switchesPlates}</div>
                          </div>
                        </Link>
                      </div>
                    </div>
                      <div className="pdp-frame-1700">
                        <Frame1686
                          text10={frame1786Props.text10}
                          text11={frame1786Props.text11}
                          className={frame1786Props.className}
                          id={frame17862Props.id}
                        />
                        <Frame1686
                          text10={frame17862Props.text10}
                          text11={frame17862Props.text11}
                          className={frame17862Props.className}
                          id={frame17863Props.id}
                        />
                        <Frame1686 
                          text10={frame17863Props.text10} 
                          text11={frame17863Props.text11} 
                          id={frame17864Props.id} 
                        />
                        <Frame1686 
                          text10={frame17864Props.text10} 
                          text11={frame17864Props.text11} 
                          id={frame17865Props.id} 
                        />
                        <Frame1686 
                          text10={frame17865Props.text10} 
                          text11={frame17865Props.text11} 
                          id={frame17866Props.id} 
                        />
                        <Frame1686 
                          text10={frame17866Props.text10} 
                          text11={frame17866Props.text11} 
                          id={frame17867Props.id} 
                        />
                        <Frame1686 
                          text10={frame17867Props.text10} 
                          text11={frame17867Props.text11} 
                          id={frame17868Props.id} 
                        />
                        <Frame1686 
                          text10={frame17868Props.text10} 
                          text11={frame17868Props.text11} 
                          id={frame17869Props.id} 
                        />
                        <Frame1686 
                          text10={frame17869Props.text10} 
                          text11={frame17869Props.text11} 
                          id={frame17870Props.id} 
                        />
                        <Frame1686 
                          text10={frame17870Props.text10} 
                          text11={frame17870Props.text11} 
                          id={frame17871Props.id} 
                        />
                        <Frame1686 
                          text10={frame17871Props.text10} 
                          text11={frame17871Props.text11} 
                          //id={frame17871Props.id} 
                        />
                      </div>
                    </div>
                  </TabPanel>
                  <TabPanel className="tab-panel">
                    <div className="pdp-rectangle-107">
                      <div className="pdp-frame-1677">
                        <div className="pdp-frame-1675">
                          <Link smooth to="#design-drawing" >
                            <div className="navigation-text active">
                              <img className="pdp-claritydesign-line " src={clarityDesignLine} />
                              <div className="pdp-design-drawings pdp-valign-text-middle text-top">{designDrawings}</div>
                            </div>
                          </Link>
                        </div>
                        <div className="pdp-frame-1676" >
                          <Link smooth to="#structure" >
                            <div className="navigation-text">
                              <img className="pdp-icon-park-outli-ebuilding-three " src={iconParkOutlineBuildingThree} />
                              <div className="pdp-structure pdp-valign-text-middle pdp-overpass-extra-bold-black-16px text-top">{structure}</div>
                            </div>
                          </Link>
                        </div>
                        <div className="pdp-frame-1677-1" >
                          <Link smooth to="#door-frames">
                            <div className="navigation-text">
                              <img className="pdp-bidoor-open " src={biDoorOpen} />
                              <div className="pdp-door-frames pdp-valign-text-middle pdp-overpass-extra-bold-black-16px text-top">{doorFrames}</div>
                            </div>
                          </Link>
                        </div>
                        <div className="pdp-frame-1678">
                          <Link smooth to="#door-shutters">
                            <div className="navigation-text">
                              <img className="pdp-mdiwindow-shutter" src={mdiWindowShutter} />
                              <div className="pdp-door-shutters pdp-valign-text-middle pdp-overpass-extra-bold-black-16px text-top">{doorShutters}</div>
                            </div>
                          </Link>
                        </div>
                        <div className="pdp-frame-1679">
                          <Link smooth to="#door-fittings">
                            <div className="navigation-text">
                              <img className="pdp-icon-park-outlinedoor-handle" src={iconParkOutlineDoorHandle} />
                              <div className="pdp-door-fittings pdp-valign-text-middle pdp-overpass-extra-bold-black-16px text-top">{doorFittings}</div>
                            </div>
                          </Link>
                        </div>
                        <div className="pdp-frame-1680">
                          <Link smooth to="#window">
                            <div className="navigation-text">
                              <img className="pdp-tablerwindow" src={tablerWindow} />
                              <div className="pdp-window pdp-valign-text-middle pdp-overpass-extra-bold-black-16px text-top">{window}</div>
                            </div>
                          </Link>
                        </div>
                        <div className="pdp-frame-1681">
                          <Link smooth to="#flooring">
                            <div className="navigation-text">
                              <img className="pdp-icbaseline-grid-on" src={icBaselineGridOn} />
                              <div className="pdp-flooring pdp-valign-text-middle pdp-overpass-extra-bold-black-16px text-top">{flooring}</div>
                            </div>
                          </Link>
                        </div>
                        <div className="pdp-frame-1681">
                          <Link smooth to="#kitchen-counter">
                            <div className="navigation-text">
                              <img className="pdp-icbaseline-grid-on" src={frame} />
                              <div className="pdp-flooring pdp-valign-text-middle pdp-overpass-extra-bold-black-16px text-top">{kitchenCounter}</div>
                            </div>
                          </Link>
                        </div>
                        <div className="pdp-frame-1681">
                          <Link smooth to="#bathroom">
                            <div className="navigation-text">
                              <img className="pdp-icbaseline-grid-on" src={frame1683} />
                              <div className="pdp-flooring pdp-valign-text-middle pdp-overpass-extra-bold-black-16px text-top">{bathroom}</div>
                            </div>
                          </Link>
                        </div>
                        <div className="pdp-frame-1681">
                          <Link smooth to="#painting">
                            <div className="navigation-text">
                              <img className="pdp-icbaseline-grid-on" src={frame1684} />
                              <div className="pdp-flooring pdp-valign-text-middle pdp-overpass-extra-bold-black-16px text-top">{painting}</div>
                            </div>
                          </Link>
                        </div>
                        <div className="pdp-frame-1681">
                          <Link smooth to="#switches-plates">
                            <div className="navigation-text">
                              <img className="pdp-icbaseline-grid-on" src={frame1685} />
                              <div className="pdp-flooring pdp-valign-text-middle pdp-overpass-extra-bold-black-16px text-top">{switchesPlates}</div>
                            </div>
                          </Link>
                        </div>
                      </div>
                      <div className="pdp-frame-1700">
                        <Frame1686 
                          text10={frame1886Props.text10} 
                          text11={frame1886Props.text11} 
                          id={frame18862Props.id} 
                        />
                        <Frame1686
                          text10={frame18862Props.text10}
                          text11={frame18862Props.text11}
                          className={frame18862Props.className}
                          id={frame18863Props.id}
                        />
                        <Frame1686
                          text10={frame18863Props.text10}
                          text11={frame18863Props.text11}
                          className={frame18863Props.className}
                          id={frame18864Props.id}
                        />
                        <Frame1686
                          text10={frame18864Props.text10}
                          text11={frame18864Props.text11}
                          className={frame18864Props.className}
                          id={frame18865Props.id}
                        />
                        <Frame1686
                          text10={frame18865Props.text10}
                          text11={frame18865Props.text11}
                          className={frame18865Props.className}
                          id={frame18866Props.id}
                        />
                        <Frame1686
                          text10={frame18866Props.text10}
                          text11={frame18866Props.text11}
                          className={frame18866Props.className}
                          id={frame18867Props.id}
                        />
                        <Frame1686
                          text10={frame18867Props.text10}
                          text11={frame18867Props.text11}
                          className={frame18867Props.className}
                          id={frame18868Props.id}
                        />
                        <Frame1686
                          text10={frame18868Props.text10}
                          text11={frame18868Props.text11}
                          className={frame18868Props.className}
                          id={frame18869Props.id}
                        />
                        <Frame1686
                          text10={frame18869Props.text10}
                          text11={frame18869Props.text11}
                          className={frame18869Props.className}
                          id={frame18870Props.id}
                        />
                        <Frame1686
                          text10={frame18870Props.text10}
                          text11={frame18870Props.text11}
                          className={frame18870Props.className}
                          id={frame18871Props.id}
                        />
                        <Frame1686
                          text10={frame18871Props.text10}
                          text11={frame18871Props.text11}
                          className={frame18871Props.className}
                          //id={frame18871Props.id}
                        />
                      </div>
                    </div>
                  </TabPanel>
                  <TabPanel className="tab-panel">
                    <div className="pdp-rectangle-107">
                    <div className="pdp-frame-1677">
                      <div className="pdp-frame-1675">
                        <Link smooth to="#design-drawing" >
                          <div className="navigation-text active">
                            <img className="pdp-claritydesign-line " src={clarityDesignLine} />
                            <div className="pdp-design-drawings pdp-valign-text-middle text-top">{designDrawings}</div>
                          </div>
                        </Link>
                      </div>
                      <div className="pdp-frame-1676" >
                        <Link smooth to="#structure" >
                          <div className="navigation-text">
                            <img className="pdp-icon-park-outli-ebuilding-three " src={iconParkOutlineBuildingThree} />
                            <div className="pdp-structure pdp-valign-text-middle pdp-overpass-extra-bold-black-16px text-top">{structure}</div>
                          </div>
                        </Link>
                      </div>
                      <div className="pdp-frame-1677-1" >
                        <Link smooth to="#door-frames">
                          <div className="navigation-text">
                            <img className="pdp-bidoor-open " src={biDoorOpen} />
                            <div className="pdp-door-frames pdp-valign-text-middle pdp-overpass-extra-bold-black-16px text-top">{doorFrames}</div>
                          </div>
                        </Link>
                      </div>
                      <div className="pdp-frame-1678">
                        <Link smooth to="#door-shutters">
                          <div className="navigation-text">
                            <img className="pdp-mdiwindow-shutter" src={mdiWindowShutter} />
                            <div className="pdp-door-shutters pdp-valign-text-middle pdp-overpass-extra-bold-black-16px text-top">{doorShutters}</div>
                          </div>
                        </Link>
                      </div>
                      <div className="pdp-frame-1679">
                        <Link smooth to="#door-fittings">
                          <div className="navigation-text">
                            <img className="pdp-icon-park-outlinedoor-handle" src={iconParkOutlineDoorHandle} />
                            <div className="pdp-door-fittings pdp-valign-text-middle pdp-overpass-extra-bold-black-16px text-top">{doorFittings}</div>
                          </div>
                        </Link>
                      </div>
                      <div className="pdp-frame-1680">
                        <Link smooth to="#window">
                          <div className="navigation-text">
                            <img className="pdp-tablerwindow" src={tablerWindow} />
                            <div className="pdp-window pdp-valign-text-middle pdp-overpass-extra-bold-black-16px text-top">{window}</div>
                          </div>
                        </Link>
                      </div>
                      <div className="pdp-frame-1681">
                        <Link smooth to="#flooring">
                          <div className="navigation-text">
                            <img className="pdp-icbaseline-grid-on" src={icBaselineGridOn} />
                            <div className="pdp-flooring pdp-valign-text-middle pdp-overpass-extra-bold-black-16px text-top">{flooring}</div>
                          </div>
                        </Link>
                      </div>
                      <div className="pdp-frame-1681">
                        <Link smooth to="#kitchen-counter">
                          <div className="navigation-text">
                            <img className="pdp-icbaseline-grid-on" src={frame} />
                            <div className="pdp-flooring pdp-valign-text-middle pdp-overpass-extra-bold-black-16px text-top">{kitchenCounter}</div>
                          </div>
                        </Link>
                      </div>
                      <div className="pdp-frame-1681">
                        <Link smooth to="#bathroom">
                          <div className="navigation-text">
                            <img className="pdp-icbaseline-grid-on" src={frame1683} />
                            <div className="pdp-flooring pdp-valign-text-middle pdp-overpass-extra-bold-black-16px text-top">{bathroom}</div>
                          </div>
                        </Link>
                      </div>
                      <div className="pdp-frame-1681">
                        <Link smooth to="#painting">
                          <div className="navigation-text">
                            <img className="pdp-icbaseline-grid-on" src={frame1684} />
                            <div className="pdp-flooring pdp-valign-text-middle pdp-overpass-extra-bold-black-16px text-top">{painting}</div>
                          </div>
                        </Link>
                      </div>
                      <div className="pdp-frame-1681">
                        <Link smooth to="#switches-plates">
                          <div className="navigation-text">
                            <img className="pdp-icbaseline-grid-on" src={frame1685} />
                            <div className="pdp-flooring pdp-valign-text-middle pdp-overpass-extra-bold-black-16px text-top">{switchesPlates}</div>
                          </div>
                        </Link>
                      </div>
                    </div>
                      <div className="pdp-frame-1700">
                      <Frame1686
                          text10={frame1986Props.text10}
                          text11={frame1986Props.text11}
                          className={frame1986Props.className}
                          id={frame19862Props.id}
                        />
                        <Frame1686
                          text10={frame19862Props.text10}
                          text11={frame19862Props.text11}
                          className={frame19862Props.className}
                          id={frame19863Props.id}
                        />
                        <Frame1686 
                          text10={frame19863Props.text10} 
                          text11={frame19863Props.text11} 
                          id={frame19864Props.id} 
                        />
                        <Frame1686 
                          text10={frame19864Props.text10} 
                          text11={frame19864Props.text11} 
                          id={frame19865Props.id} 
                        />
                        <Frame1686 
                          text10={frame19865Props.text10} 
                          text11={frame19865Props.text11} 
                          id={frame19866Props.id} 
                        />
                        <Frame1686 
                          text10={frame19866Props.text10} 
                          text11={frame19866Props.text11} 
                          id={frame19867Props.id} 
                        />
                        <Frame1686 
                          text10={frame19867Props.text10} 
                          text11={frame19867Props.text11} 
                          id={frame19868Props.id} 
                        />
                        <Frame1686 
                          text10={frame19868Props.text10} 
                          text11={frame19868Props.text11} 
                          id={frame19869Props.id} 
                        />
                        <Frame1686 
                          text10={frame19869Props.text10} 
                          text11={frame19869Props.text11} 
                          id={frame19870Props.id} 
                        />
                        <Frame1686 
                          text10={frame19870Props.text10} 
                          text11={frame19870Props.text11} 
                          id={frame19871Props.id} 
                        />
                        <Frame1686 
                          text10={frame19871Props.text10} 
                          text11={frame19871Props.text11} 
                          //id={frame19871Props.id} 
                        />
                      </div>
                    </div>
                  </TabPanel>
                </Tabs>
                <div className="pdp-rectangle-1007 typhograghy">
                  <div className="pdp-note-text lpd-typographybody16-regular" style={{marginLeft:"5%", width:"90%"}}>
                    <h3>Note :</h3>
                    <ul>
                      <li>Parking cost will be 75% of Built-up Area Costs</li>
                      <li>Other Works/Additional Cost :</li><br/>
                    <ul>
                      <li>Construction of sump tank using Blocks / Bricks including fixing of chicken mesh and smooth plastering with waterproofing</li>
                      <li>4’ Height front compound wall (as per Architectural design) over 3 courses of SSM foundation including excavation, PCC, Solid Blocks.</li>
                      <li>4’ Height MS Main Gate as per Architect Design</li>
                      <li>Flagging concrete Protection around the building in PCC 1:3:6, plastering in CM to the exposed surface, etc.(2’ Offset)</li>
                      <li>Rainwater Harvesting.</li>
                      <li>Outside drainage stone slab and bottom construction.</li>
                      <li>Front elevation as per design. (Design to be finalized)</li>
                      <li>Soil Conditions assumed to have an SBC of 180kN/m2 at 5’ depth from EGL (if rock drilling or the water table is present at the site, additional cost to be added as per the existing site conditions).</li><br/>
                    </ul>
                    <li>Design Cost will be as follows:</li>
                    </ul>
                    <div style={{overflowX:"auto"}}>
                      <table style={{marginBottom:"20px"}}>
                        <tr>
                          <th style={{padding:"0px 0px"}}>Dimensions(Ft)</th>
                          <th>*Rate( For Design & Build Only)</th>
                          <th>Details</th>
                        </tr>
                        <tr>
                          <td>20x30</td>
                          <td>30,000</td>
                          <td rowSpan="7"><p>Design & Drawings( For Design & Build Only):</p><ul style={{marginLeft:"10px"}}><li style={{textAlign:"left"}}>Floor Plan</li><li style={{textAlign:"left"}}>Front Elevation</li><li style={{textAlign:"left"}}>Structural Drawings:</li><ul style={{marginLeft:"10px"}}><li style={{textAlign:"left"}}>Columns Position</li><li style={{textAlign:"left"}}>Foundation Footing & Columns Details</li></ul></ul></td>
                        </tr>
                        <tr>
                          <td>30x40</td>
                          <td>35,000</td>
                        </tr>
                        <tr>
                          <td>30x50</td>
                          <td>35,000</td>
                        </tr>
                        <tr>
                          <td>30x60, 40x40</td>
                          <td>40,000</td>
                        </tr>
                        <tr>
                          <td>40x50</td>
                          <td>40,000</td>
                        </tr>
                        <tr>
                          <td>40x60</td>
                          <td>50,000</td>
                        </tr>
                        <tr>
                          <td>50x80</td>
                          <td>75,000</td>
                        </tr>
                      </table>
                    </div>
                  </div>
                </div>
              </TabPanel>
              <TabPanel>
              <div style={{overflowX:"auto", width:"60%", marginLeft:"20%" }}>
                <table style={{marginBottom:"20px", height:"200px"}}>
                  <tr>
                    <th> Min</th>
                    <th>Basic</th>
                    <th>Std</th>
                    <th>Premium</th>
                    <th>Luxury</th>
                  </tr>
                  <tr>
                    <td>1BHK</td>
                    <td>₹ 1,50,000</td>
                    <td>₹ 2,25,000</td>
                    <td>₹ 4,75,000</td>
                    <td>₹ 6,75,000</td>
                  </tr>
                  <tr>
                    <td>2BHK</td>
                    <td>₹ 2,25,000</td>
                    <td>₹ 3,25,000</td>
                    <td>₹ 6,00,000</td>
                    <td>₹ 8,50,000</td>
                  </tr>
                  <tr>
                    <td>3BHK</td>
                    <td>₹ 3,00,000</td>
                    <td>₹ 4,25,000</td>
                    <td>₹ 7,25,000</td>
                    <td>₹ 10,25,000</td>

                  </tr>
                  <tr>
                    <td>4BHK</td>
                    <td>₹ 3,75,000</td>
                    <td>₹ 5,25,000</td>
                    <td>₹ 8,50,000</td>
                    <td>₹ 12,00,000</td>
                  </tr>
                </table>
              </div>
                <Tabs className="tab" defaultIndex={packageid-1} selectedTabClassName="tab-li tab-active">
                  <TabList className="tab-list">
                    <Tab className="tab-li">
                      <div className="pdp-frame-1695">
                        <div className="pdp-basic pdp-valign-text-middle pdp-overpass-extra-bold-white-24px tab-text-margin">{basic}</div>
                      </div>
                      <div id="kitchen"></div>
                    </Tab>
                    <Tab className="tab-li">
                      <div className="pdp-frame-1696">
                        <div className="pdp-place pdp-valign-text-middle pdp-overpass-extra-bold-mine-shaft-24px tab-text-margin">{place}</div>
                      </div>
                    </Tab>
                    <Tab className="tab-li">
                      <div className="pdp-frame-1697">
                        <div className="pdp-premium pdp-valign-text-middle pdp-overpass-extra-bold-mine-shaft-24px tab-text-margin">{premium}</div>
                      </div>
                    </Tab>
                    <Tab className="tab-li">
                      <div className="pdp-frame-1698">
                        <div className="pdp-luxury pdp-valign-text-middle pdp-overpass-extra-bold-mine-shaft-24px tab-text-margin">{luxury}</div>
                      </div>
                    </Tab>
                  </TabList>
                  <TabPanel className="tab-panel">
                    <div className="pdp-rectangle-107">
                      <div className="pdp-frame-1677">
                        <div className="pdp-frame-1675">
                          <Link smooth to="#kitchen">
                            <div className="navigation-text active">
                              <img className="pdp-icon-park-outli-ebuilding-three" src={frame} />
                              <div className="pdp-structure pdp-valign-text-middle pdp-overpass-extra-bold-black-16px">{kitchen}</div>
                            </div>
                          </Link>
                        </div>
                        <div className="pdp-frame-1677-1">
                          <Link smooth to="#bedroom">
                            <div className="navigation-text">
                              <img className="pdp-bidoor-open" src={bedRoom} />
                              <div className="pdp-door-frames pdp-valign-text-middle pdp-overpass-extra-bold-black-16px">{bedroom}</div>
                            </div>
                          </Link>
                        </div>
                        <div className="pdp-frame-1678">
                          <Link smooth to="#tv-unit">
                            <div className="navigation-text">
                              <img className="pdp-mdiwindow-shutter" src={tv} />
                              <div className="pdp-door-shutters pdp-valign-text-middle pdp-overpass-extra-bold-black-16px">{tvUnit}</div>
                            </div>
                          </Link>
                        </div>
                      </div>
                      <div className="pdp-frame-1700">
                        <Frame1686 
                          text10={frame2086Props.text10} 
                          text11={frame2086Props.text11} 
                          id={frame20862Props.id} />
                        <Frame1686
                          text10={frame20862Props.text10}
                          text11={frame20862Props.text11}
                          className={frame20862Props.className}
                          id={frame20863Props.id}
                        />
                        <Frame1686
                          text10={frame20863Props.text10}
                          text11={frame20863Props.text11}
                          className={frame20863Props.className}
                          id={frame20864Props.id}
                        />
                        <Frame1686
                          text10={frame20864Props.text10}
                          text11={frame20864Props.text11}
                          className={frame20864Props.className}
                          //id={frame20864Props.id}
                        />
                      </div>
                    </div>
                  </TabPanel>
                  <TabPanel className="tab-panel">
                    <div className="pdp-rectangle-107">
                      <div className="pdp-frame-1677">
                      <div className="pdp-frame-1675">
                        <Link smooth to="#kitchen">
                          <div className="navigation-text active">
                            <img className="pdp-icon-park-outli-ebuilding-three" src={frame} />
                            <div className="pdp-structure pdp-valign-text-middle pdp-overpass-extra-bold-black-16px ">{kitchen}</div>
                          </div>
                        </Link>
                        </div>
                        <div className="pdp-frame-1677-1">
                          <Link smooth to="#bedroom">
                            <div className="navigation-text">
                              <img className="pdp-bidoor-open" src={bedRoom} />
                              <div className="pdp-door-frames pdp-valign-text-middle pdp-overpass-extra-bold-black-16px">{bedroom}</div>
                            </div>
                          </Link>
                        </div>
                        <div className="pdp-frame-1678">
                          <Link to="#tv-unit">
                            <div className="navigation-text">
                              <img className="pdp-mdiwindow-shutter" src={tv} />
                              <div className="pdp-door-shutters pdp-valign-text-middle pdp-overpass-extra-bold-black-16px">{tvUnit}</div>
                            </div>
                          </Link>
                        </div>
                        <div className="pdp-frame-1678">
                          <Link to="#pooja-unit">
                            <div className="navigation-text">
                              <img className="pdp-mdiwindow-shutter" src={poojaRoom} />
                              <div className="pdp-door-shutters pdp-valign-text-middle pdp-overpass-extra-bold-black-16px">{poojaUnit}</div>
                            </div>
                          </Link>
                        </div>
                      </div>
                      <div className="pdp-frame-1700">
                        <Frame1686 
                          text10={frame2087Props.text10} 
                          text11={frame2087Props.text11} 
                          id={frame20862Props.id} />
                        <Frame1686
                          text10={frame20872Props.text10}
                          text11={frame20872Props.text11}
                          className={frame20872Props.className}
                          id={frame20873Props.id}
                        />
                        <Frame1686
                          text10={frame20873Props.text10}
                          text11={frame20873Props.text11}
                          className={frame20873Props.className}
                          id={frame20874Props.id}
                        />
                        <Frame1686
                          text10={frame20874Props.text10}
                          text11={frame20874Props.text11}
                          className={frame20874Props.className}
                          id={frame20875Props.id}
                        />
                        <Frame1686
                          text10={frame20875Props.text10}
                          text11={frame20875Props.text11}
                          className={frame20875Props.className}
                          //id={frame20875Props.id}
                        />
                      </div>
                    </div>
                  </TabPanel>
                  <TabPanel className="tab-panel">
                    <div className="pdp-rectangle-107">
                      <div className="pdp-frame-1677">
                      <div className="pdp-frame-1675">
                        <Link smooth to="#kitchen">
                          <div className="navigation-text active">
                            <img className="pdp-icon-park-outli-ebuilding-three" src={frame} />
                            <div className="pdp-structure pdp-valign-text-middle pdp-overpass-extra-bold-black-16px">{kitchen}</div>
                          </div>
                        </Link>
                        </div>
                        <div className="pdp-frame-1677-1">
                          <Link smooth to="#bedroom">
                            <div className="navigation-text">
                              <img className="pdp-bidoor-open" src={bedRoom} />
                              <div className="pdp-door-frames pdp-valign-text-middle pdp-overpass-extra-bold-black-16px">{bedroom}</div>
                            </div>
                          </Link>
                        </div>
                        <div className="pdp-frame-1678">
                          <Link to="#tv-unit">
                            <div className="navigation-text">
                              <img className="pdp-mdiwindow-shutter" src={tv} />
                              <div className="pdp-door-shutters pdp-valign-text-middle pdp-overpass-extra-bold-black-16px">{tvUnit}</div>
                            </div>
                          </Link>
                        </div>
                        <div className="pdp-frame-1678">
                          <Link to="#pooja-unit">
                            <div className="navigation-text">
                              <img className="pdp-mdiwindow-shutter" src={poojaRoom} />
                              <div className="pdp-door-shutters pdp-valign-text-middle pdp-overpass-extra-bold-black-16px">{poojaUnit}</div>
                            </div>
                          </Link>
                        </div>
                        <div className="pdp-frame-1678">
                          <Link to="#crockery-unit">
                            <div className="navigation-text">
                              <img className="pdp-mdiwindow-shutter" src={crockery} />
                              <div className="pdp-door-shutters pdp-valign-text-middle pdp-overpass-extra-bold-black-16px">{crockeryUnit}</div>
                            </div>
                          </Link>
                        </div>
                        <div className="pdp-frame-1678">
                          <Link to="#study-unit">
                            <div className="navigation-text">
                              <img className="pdp-mdiwindow-shutter" src={study} />
                              <div className="pdp-door-shutters pdp-valign-text-middle pdp-overpass-extra-bold-black-16px" style={{justifyContent:"inherit"}}>{studyUnit}</div>
                            </div>
                          </Link>
                        </div>
                        <div className="pdp-frame-1678">
                          <Link to="#false-ceiling">
                            <div className="navigation-text">
                              <img className="pdp-mdiwindow-shutter" src={ceiling} />
                              <div className="pdp-door-shutters pdp-valign-text-middle pdp-overpass-extra-bold-black-16px">{falseCeiling}</div>
                            </div>
                          </Link>
                        </div>
                      </div>
                      <div className="pdp-frame-1700">
                        <Frame1686 
                          text10={frame2088Props.text10} 
                          text11={frame2088Props.text11} 
                          id={frame20882Props.id} />
                        <Frame1686
                          text10={frame20882Props.text10}
                          text11={frame20882Props.text11}
                          className={frame20882Props.className}
                          id={frame20883Props.id}
                        />
                        <Frame1686
                          text10={frame20883Props.text10}
                          text11={frame20883Props.text11}
                          className={frame20883Props.className}
                          id={frame20884Props.id}
                        />
                        <Frame1686
                          text10={frame20884Props.text10}
                          text11={frame20884Props.text11}
                          className={frame20884Props.className}
                          id={frame20885Props.id}
                        />
                        <Frame1686
                          text10={frame20885Props.text10}
                          text11={frame20885Props.text11}
                          className={frame20885Props.className}
                          id={frame20886Props.id}
                        />
                        <Frame1686
                          text10={frame20886Props.text10}
                          text11={frame20886Props.text11}
                          className={frame20886Props.className}
                          id={frame20887Props.id}
                        />
                        <Frame1686
                          text10={frame20887Props.text10}
                          text11={frame20887Props.text11}
                          className={frame20887Props.className}
                          id={frame20888Props.id}
                        />
                        <Frame1686
                          text10={frame20888Props.text10}
                          text11={frame20888Props.text11}
                          className={frame20888Props.className}
                          //id={frame20888Props.id}
                        />
                      </div>
                    </div>
                  </TabPanel>
                  <TabPanel className="tab-panel">
                    <div className="pdp-rectangle-107">
                      <div className="pdp-frame-1677">
                      <div className="pdp-frame-1675">
                        <Link smooth to="#kitchen">
                          <div className="navigation-text active">
                            <img className="pdp-icon-park-outli-ebuilding-three" src={frame} />
                            <div className="pdp-structure pdp-valign-text-middle pdp-overpass-extra-bold-black-16px">{kitchen}</div>
                          </div>
                        </Link>
                        </div>
                        <div className="pdp-frame-1677-1">
                          <Link smooth to="#bedroom">
                            <div className="navigation-text">
                              <img className="pdp-bidoor-open" src={bedRoom} />
                              <div className="pdp-door-frames pdp-valign-text-middle pdp-overpass-extra-bold-black-16px">{bedroom}</div>
                            </div>
                          </Link>
                        </div>
                        <div className="pdp-frame-1678">
                          <Link to="#tv-unit">
                            <div className="navigation-text">
                              <img className="pdp-mdiwindow-shutter" src={tv} />
                              <div className="pdp-door-shutters pdp-valign-text-middle pdp-overpass-extra-bold-black-16px">{tvUnit}</div>
                            </div>
                          </Link>
                        </div>
                        <div className="pdp-frame-1678">
                          <Link to="#pooja-unit">
                            <div className="navigation-text">
                              <img className="pdp-mdiwindow-shutter" src={poojaRoom} />
                              <div className="pdp-door-shutters pdp-valign-text-middle pdp-overpass-extra-bold-black-16px">{poojaUnit}</div>
                            </div>
                          </Link>
                        </div>
                        <div className="pdp-frame-1678">
                          <Link to="#crockery-unit">
                            <div className="navigation-text">
                              <img className="pdp-mdiwindow-shutter" src={crockery} />
                              <div className="pdp-door-shutters pdp-valign-text-middle pdp-overpass-extra-bold-black-16px">{crockeryUnit}</div>
                            </div>
                          </Link>
                        </div>
                        <div className="pdp-frame-1678">
                          <Link to="#study-unit">
                            <div className="navigation-text">
                              <img className="pdp-mdiwindow-shutter" src={study} />
                              <div className="pdp-door-shutters pdp-valign-text-middle pdp-overpass-extra-bold-black-16px" style={{justifyContent:"inherit"}}>{studyUnit}</div>
                            </div>
                          </Link>
                        </div>
                        <div className="pdp-frame-1678">
                          <Link to="#false-ceiling">
                            <div className="navigation-text">
                              <img className="pdp-mdiwindow-shutter" src={ceiling} />
                              <div className="pdp-door-shutters pdp-valign-text-middle pdp-overpass-extra-bold-black-16px">{falseCeiling}</div>
                            </div>
                          </Link>
                        </div>
                        <div className="pdp-frame-1678">
                          <Link to="#shoe-rack">
                            <div className="navigation-text">
                              <img className="pdp-mdiwindow-shutter" src={shoe} />
                              <div className="pdp-door-shutters pdp-valign-text-middle pdp-overpass-extra-bold-black-16px">{shoeRack}</div>
                            </div>
                          </Link>
                        </div>
                      </div>
                      <div className="pdp-frame-1700">
                        <Frame1686 
                          text10={frame2089Props.text10} 
                          text11={frame2089Props.text11} 
                          id={frame20892Props.id} />
                        <Frame1686
                          text10={frame20892Props.text10}
                          text11={frame20892Props.text11}
                          className={frame20892Props.className}
                          id={frame20893Props.id}
                        />
                        <Frame1686
                          text10={frame20893Props.text10}
                          text11={frame20893Props.text11}
                          className={frame20893Props.className}
                          id={frame20894Props.id}
                        />
                        <Frame1686
                          text10={frame20894Props.text10}
                          text11={frame20894Props.text11}
                          className={frame20894Props.className}
                          id={frame20895Props.id}
                        />
                        <Frame1686
                          text10={frame20895Props.text10}
                          text11={frame20895Props.text11}
                          className={frame20895Props.className}
                          id={frame20896Props.id}
                        />
                        <Frame1686
                          text10={frame20896Props.text10}
                          text11={frame20896Props.text11}
                          className={frame20896Props.className}
                          id={frame20897Props.id}
                        />
                        <Frame1686
                          text10={frame20897Props.text10}
                          text11={frame20897Props.text11}
                          className={frame20897Props.className}
                          id={frame20898Props.id}
                        />
                        <Frame1686
                          text10={frame20898Props.text10}
                          text11={frame20898Props.text11}
                          className={frame20898Props.className}
                          id={frame20899Props.id}
                        />
                        <Frame1686
                          text10={frame20899Props.text10}
                          text11={frame20899Props.text11}
                          className={frame20899Props.className}
                          //id={frame20899Props.id}
                        />
                      </div>
                    </div>
                  </TabPanel>
                </Tabs>
              </TabPanel>
            </Tabs>
    </>
  );
}



function Group102(props) {
  const { place, group103Props } = props;

  return (
    <div className="pdp-group-102">
      <Group103>{group103Props.children}</Group103>
      <div className="pdp-place-2 lpd-overpass-extra-bold-shark-14px">{place}</div>
    </div>
  );
}


function Group103(props) {
  const { children } = props;

  return (
    <div className="pdp-group-103">
      <div className="pdp-overlap-group1">
        <div className="pdp-rectangle-46"></div>
        <div className="pdp-construction lpd-overpass-extra-bold-shark-14px">{children}</div>
      </div>
    </div>
  );
}


function Frame692(props) {
  const { number, rsSft, className } = props;

  return (
    <div className={`pdp-frame-69-1 ${className || ""}`}>
      <div className="pdp-number-1 pdp-valign-text-middle pdp-overpass-extra-bold-black-24px2">{number}</div>
      <div className="pdp-rs-sft-1 pdp-valign-text-middle pdp-overpass-normal-mine-shaft-16px">{rsSft}</div>
    </div>
  );
}


function Frame1686(props) {
  const { text10, text11, className,id } = props;

  return (
    <div className={`pdp-frame-1686 ${className || ""}`}>
      <div  className="pdp-text-3 pdp-valign-text-middle pdp-overpass-extra-bold-black-16px">{text10}</div>
      <p className="pdp-text-4 pdp-overpass-normal-scarpa-flow-12px">{text11}</p>
      <p id={`${id}`}></p>
    </div>
  );
}

const group103Data = {
    children: "CONSTRUCTION",
};

const group102Data = {
    place: "INTERIOR",
    group103Props: group103Data,
};

const frame692Data = {
    number: "1600",
    rsSft: "Rs/Sft",
};

const frame6922Data = {
    number: "1600",
    rsSft: "Rs/Sft",
    className: "pdp-frame-69-2",
};

const frame6923Data = {
    number: "1600",
    rsSft: "Rs/Sft",
    className: "pdp-frame-69-3",
};

// Construction Basic Content starts//

const frame1686Data = {
    id:"design-drawing",
    text10: "Design & Drawings",
    text11: <ul><li>Floor Plan </li><li>Front Elevation </li><li>Structural Drawings:</li><ul style={{marginLeft:"20px"}}><li>Columns Position</li><li>Foundation Footing &amp; Columns Details</li></ul></ul>,
};

const frame16862Data = {
    id:"structure",
    text10: "Structure",
    text11: <ul><li>Steel: Turbo, Meenakshi, Sunvik or equivalent brand. (TMT Reinforcement Steel to be provided at 2.75 kgs/sft of built up area. All Steel designs are as per Structural engineer‘s drawing)</li><li>Cement: Ramco, Bharathi, Birla Shakti, ACC or equivalent Brand(53 Grade for Concrete works &amp; 43 Grade for other works)</li><li>RMC: ACC or Ultratech </li><li>PCC Works of M15 Grade 1 : 2 :4 </li><li>RCC Works of M 25 Grade for Column Footing, Plinth Beams, Columns and Roof Slabs. Thickness of roof slab shall be 5” thick</li><li>RCC Works of M 20 Grade for Lintel, Canopy Projections, Staircase </li><li>Column Sizes will be of 8”x18” min </li><li>Soil testing (SBC of 180kN/m2 at 5’ depth from EGL)</li><li>Water Proofing: Dr. Fixit</li><li>Roof to Roof Height be 10’0”</li><li>6” Blocks for Exterior &amp; 4” for Interior</li><li>Window Area will 125sft for Every 1000sft of Bulit Up Area</li></ul>,
    className: "pdp-frame-168",
};
const frame16863Data = {
    id:"door-frames",
    text10: "Door Frames",
    text11: <ul><li>SMain Door – Red Sal Frame of size 5” x 4”</li><li>Pooja Door - Honne Frame of Size 5”x 3”.</li><li>Internal Doors - All internal Doors including Red Sal of size 5”x 21/2”</li><li>Bathroom Doors - Red Sal of size 5”x 21/2”</li></ul>,
    className: "pdp-frame-168",
};
const frame16864Data = {
  id:"door-shutters",
  text10: "Door Shutters",
  text11: <ul><li>Main Door - 1 ½” thick Honne Shutter.</li><li>Pooja Room Door - 1 ½” thick Honne Shutters.</li><li>Internal Door- Readymade Solid Doors of 1 ½” thick.</li><li>Bathroom Doors: FRP Doors.</li></ul>,
  className: "pdp-frame-168",
};
const frame16865Data = {
  id:"door-fittings",
  text10: "Door Fittings",
  text11: <ul><li>Main door and Pooja door are installed with Brass fittings.</li><li>Internal doors are installed with SS Fittings.</li></ul>,
  className: "pdp-frame-168",
};
const frame16866Data = {
  id:"window",
  text10: "Window",
  text11: <ul><li>AL window: Rs.220/sqft  for 125sqft for every 1000sft of BUA</li><li>Window grill Rs.150/-Sqft (Simple Design)</li></ul>,
  className: "pdp-frame-168",
};
const frame16867Data = {
  id:"flooring",
  text10: "Flooring",
  text11: <ul><li>Internal bedrooms will have vitrified flooring worth 50 rupees per square foot, tax included.</li><li>Granite flooring will be installed for a staircase of 65Rs/sqft inclusive of tax.</li><li>Ceramic Tiles for Parking and balcony Flooring (Cost of Tile Rs. 50/Sft).</li></ul>,
  className: "pdp-frame-168",
};
const frame16868Data = {
  id:"kitchen-counter",
  text10: "Kitchen Counter",
  text11: <ul><li>4’0” feet height Glazed tiles (Cost Rs.50/sqft) over 20mm thick Hassan Green granite platform one side with 18”x21” SS sink.</li></ul>,
  className: "pdp-frame-168",
};
const frame16869Data = {
  id:"bathroom",
  text10: "Bathroom",
  text11: <ul><li>Anti-skid Ceramic Tile flooring for Toilets only (Cost of Tile Rs.40/Sft- Inclusive of tax).</li><li>Dadoing Works - 7’ Height. Cost of Tile Rs.40/Sft Inclusive of tax</li><li>Bathroom Fittings - Rs 12,000 MRP for each Bathroom includes a floor-mounted closet, Washbasin & CP fittings of Cera, Parry Ware or, equivalent make.</li></ul>,
  className: "pdp-frame-168",
};
const frame16870Data = {
  id:"painting",
  text10: "Painting",
  text11: <ul><li>Internal Walls and Ceilings- Two coats Tractor Emulsion of ASIAN PAINT over 1 coat of primer & 2 coats of putty.</li><li>External - Two coats of ACE of ASIAN Paints over 1 coat of external primer.</li></ul>,
  className: "pdp-frame-168",
};
const frame16871Data = {
  id:"switches-plates",
  text10: "Switches/Plates",
  text11: <ul><li>Anchor switches/Plates of Model Roma.</li></ul>,
  className: "pdp-frame-168",
};

// Construction Basic Content Ends//

// Construction Standard Content Starts//

const frame1786Data = {
  id:"design-drawing",
  text10: "Design & Drawings",
  text11: <ul><li>Floor Plan </li><li>Front Elevation </li><li>Structural Drawings:</li><ul style={{marginLeft:"20px"}}><li>Columns Position</li><li>Foundation Footing &amp; Columns Details</li></ul></ul>,
};
const frame17862Data = {
  id:"structure",
  text10: "Structure",
  text11: <ul><li>Steel: Turbo, Meenakshi, Sunvik, or equivalent brand. (TMT Reinforcement Steel to be provided at 2.75 kgs/sqft of built-up area. All Steel designs are as per the Structural engineer‘s drawing)</li><li>Cement: Ramco, Bharathi, Birla Shakti, ACC or equivalent Brand (53 Grade for Concrete works & 43 Grade for other works)</li><li>RMC: ACC or Ultratech</li><li>PCC Works of M15 Grade 1: 2:4 </li><li>RCC Works of M 25 Grade for Column Footing, Plinth Beams, Columns, and Roof Slabs. The thickness of the roof slab shall be 5” thick</li><li>RCC Works of M 20 Grade for Lintel, Canopy Projections, Staircase </li><li>Column Sizes will be of 8”x18” min</li><li>Soil testing (SBC of 180kN/m2 at 5’ depth from EGL)</li><li>Water Proffing: Dr. Fixit</li><li>Roof to Roof Height be 10’0”</li><li>6” Blocks for Exterior & 4” for Interior</li><li>Window Area will 125sft for Every 1000sft of Built-Up Area</li></ul>,
  className: "pdp-frame-168",
};
const frame17863Data = {
  id:"door-frames",
  text10: "Door Frames",
  text11: <ul><li>SMain Door – Red Sal Frame of size 5” x 4”</li><li>Pooja Door - Honne Frame of Size 5”x 3”.</li><li>Internal Doors - All internal Doors including Red Sal of size 5”x 21/2”</li><li>Bathroom Doors - Red Sal of size 5”x 21/2”</li></ul>,
  className: "pdp-frame-168",
};
const frame17864Data = {
  id:"door-shutters",
  text10: "Door Shutters",
  text11: <ul><li>Main Door - 1 ½” thick Honne Shutter.</li><li>Pooja Room Door - 1 ½” thick Honne Shutters.</li><li>Internal Door- Readymade Solid Doors of 1 ½” thick.</li><li>Bathroom Doors: FRP Doors.</li></ul>,
  className: "pdp-frame-168",
};
const frame17865Data = {
  id:"door-fittings",
  text10: "Door Fittings",
  text11: <ul><li>Main door and Pooja door are installed with Brass fittings.</li><li>Internal doors are installed with SS Fittings.</li></ul>,
  className: "pdp-frame-168",
};
const frame17866Data = {
  id:"window",
  text10: "Window",
  text11: <ul><li>UPVC window: Rs.400/sqft for 125sft for every 1000sft of BUA</li><li>Window grill Rs.150/-Sft (Simple Design)</li></ul>,
  className: "pdp-frame-168",
};
const frame17867Data = {
  id:"flooring",
  text10: "Flooring",
  text11: <ul><li>Granite flooring of 90Rs/sqft Inclusive of tax will be installed for common areas (Kitchen, Living, Pooja Room & Internal staircase)</li><li>Vitrified flooring of 65 Rs/sqft Inclusive of tax will be installed for internal bedrooms.</li><li>Granite flooring will be installed for a staircase of 65Rs/sqft inclusive of tax.</li><li>Ceramic Tiles for Parking, balcony Flooring (Cost of Tile Rs. 50/Sqft).</li></ul>,
  className: "pdp-frame-168",
};
const frame17868Data = {
  id:"kitchen-counter",
  text10: "Kitchen Counter",
  text11: <ul><li>4’0” feet height Glazed tiles (Cost Rs.50/sqft) over 20mm thick Hassan Green granite platform one side with 18”x21” SS sink</li></ul>,
  className: "pdp-frame-168",
};
const frame17869Data = {
  id:"bathroom",
  text10: "Bathroom",
  text11: <ul><li>Anti-skid Ceramic Tile flooring for Toilets only (Cost of Tile Rs.50/Sft- Inclusive of tax).</li><li>Dadoing Works - 7’ Height. Cost of Tile Rs.50/Sft Inclusive of tax</li><li>Bathroom Fittings - Rs 20,000 MRP for each Bathroom includes a floor-mounted closet, Washbasin & CP fittings of Jaquar, Somany or, equivalent make.</li></ul>,
  className: "pdp-frame-168",
};
const frame17870Data = {
  id:"painting",
  text10: "Painting",
  text11: <ul><li>Internal Walls and Ceilings- Two coats Tractor Emulsion of ASIAN PAINT over 1 coat of primer & 2 coats of putty.</li><li>External - Two coats of ACE of ASIAN Paints over 1 coat of external primer.</li></ul>,
  className: "pdp-frame-168",
};
const frame17871Data = {
  id:"switches-plates",
  text10: "Switches/Plates",
  text11: <ul><li>Anchor switches/Plates of Model Roma.</li></ul>,
  className: "pdp-frame-168",
};
// Construction Standard Content Ends//

// Construction Premium Content Starts//
const frame1886Data = {
  id:"design-drawing",
  text10: "Design & Drawings",
  text11: <ul><li>Floor Plan </li><li>Front Elevation </li><li>Structural Drawings:</li><ul style={{marginLeft:"20px"}}><li>Columns Position</li><li>Foundation Footing &amp; Columns Details</li></ul></ul>,
};
const frame18862Data = {
  id:"structure",
  text10: "Structure",
  text11: <ul><li>Steel: Turbo, INDUS, or equivalent brand. (TMT Reinforcement Steel to be provided at 2.75 kgs/sqft of built-up area. All Steel designs are as per the Structural engineer‘s drawing)</li><li>Cement: Ramco, Bharathi, Birla Shakti, ACC or equivalent Brand (53 Grade for Concrete works & 43 Grade for other works)</li><li>RMC: ACC or Ultratech </li><li>PCC Works of M15 Grade 1: 2:4 </li><li>RCC Works of M 25 Grade for Column Footing, Plinth Beams, Columns, and Roof Slabs. The thickness of the roof slab shall be 5” thick</li><li>RCC Works of M 20 Grade for Lintel, Canopy Projections, Staircase</li><li>Column Sizes will be of 8”x18” min</li><li>Soil testing (SBC of 180kN/m2 at 5’ depth from EGL)</li><li>Water Proffing: Dr. Fixit</li><li>Roof to Roof Height be 10’0”</li><li>8” Blocks for Exterior & 4” for Interior</li><li>Window Area will 125sft for Every 1000sft of Built-Up Area</li></ul>,
  className: "pdp-frame-168",
};
const frame18863Data = {
  id:"door-frames",
  text10: "Door Frames",
  text11: <ul><li>Main Door – Red Sal Frame of size 5” x 4”</li><li>Pooja Door - Honne Frame of Size 5”x 3”.</li><li>Internal Doors - All internal Doors including Red Sal of size 5”x 21/2”</li><li>Bathroom Doors - Red Sal of size 5”x 21/2”</li></ul>,
  className: "pdp-frame-168",
};
const frame18864Data = {
  id:"door-shutters",
  text10: "Door Shutters",
  text11: <ul><li>Main Door - 1 ½” thick Teak Shutter.</li><li>Pooja Room Door - 1 ½” thick Teak Shutters.</li><li>Internal Door- Readymade Solid Doors of 1 ½” thick.</li><li>Bathroom Doors: FRP Doors.</li></ul>,
  className: "pdp-frame-168",
};
const frame18865Data = {
  id:"door-fittings",
  text10: "Door Fittings",
  text11: <ul><li>Main door and Pooja door are installed with Brass fittings.</li><li>Internal doors are installed with SS Fittings.</li></ul>,
  className: "pdp-frame-168",
};
const frame18866Data = {
  id:"window",
  text10: "Window",
  text11: <ul><li>Red Sal Frame & Honne : Rs.400/sft for 125sqft for every 1000sft of BUA</li><li>Window grill Rs.150/-Sft (Simple Design)</li></ul>,
  className: "pdp-frame-168",
};
const frame18867Data = {
  id:"flooring",
  text10: "Flooring",
  text11: <ul><li>Granite flooring of 150Rs/sqft Inclusive of tax will be installed for common areas (Kitchen, Living, Pooja Room & Internal staircase)</li><li>Vitrified flooring of 100 Rs/sqft Inclusive of tax will be installed for internal bedrooms.</li><li>Granite flooring will be installed for a staircase of 65Rs/sqft inclusive of tax.</li><li>Ceramic Tiles for Parking, balcony Flooring (Cost of Tile Rs. 50/Sqft).</li></ul>,
  className: "pdp-frame-168",
};
const frame18868Data = {
  id:"kitchen-counter",
  text10: "Kitchen Counter",
  text11: <ul><li>4’0” feet height Glazed tiles (Cost Rs.50/sqft) over 20mm thick Hassan Green granite platform one side with 18”x21” SS sink</li></ul>,
  className: "pdp-frame-168",
};
const frame18869Data = {
  id:"bathroom",
  text10: "Bathroom",
  text11: <ul><li>Anti-skid Ceramic Tile flooring for Toilets only (Cost of Tile Rs.50/Sft- Inclusive of tax).</li><li>Dadoing Works - 10’ Height. Cost of Tile Rs.60/Sft Inclusive of tax</li><li>Bathroom Fittings - Rs 35,000 MRP for each Bathroom includes a floor-mounted closet, Washbasin & CP fittings of Jaquar, Somany or, equivalent make.</li></ul>,
  className: "pdp-frame-168",
};
const frame18870Data = {
  id:"painting",
  text10: "Painting",
  text11: <ul><li>Internal Walls and Ceilings- Two coats Tractor Emulsion of ASIAN PAINT over 1 coat of primer & 2 coats of putty.</li><li>External - Two coats of ACE of ASIAN Paints over 1 coat of external primer.</li></ul>,
  className: "pdp-frame-168",
};
const frame18871Data = {
  id:"switches-plates",
  text10: "Switches/Plates",
  text11: <ul><li>Anchor switches/Plates of Model Roma.</li></ul>,
  className: "pdp-frame-168",
};

// Construction Premium Content Ends//

// Construction Luxury Content Starts//

const frame1986Data = {
  id:"design-drawing",
  text10: "Design & Drawings",
  text11: <ul><li>Floor Plan </li><li>Front Elevation </li><li>Structural Drawings:</li><ul style={{marginLeft:"20px"}}><li>Columns Position</li><li>Foundation Footing &amp; Columns Details</li></ul></ul>,
};
const frame19862Data = {
  id:"structure",
  text10: "Structure",
  text11: <ul><li>Steel: JSW, Vizag or equivalent brand. (TMT Reinforcement Steel to be provided at 2.75 kgs/sqft of built-up area. All Steel designs are as per the Structural engineer‘s drawing)</li><li>Cement: Ramco, Bharathi, Birla Shakti, ACC or equivalent Brand(53 Grade for Concrete works & 43 Grade for other works)</li><li>RMC: ACC or Ultratech</li><li>PCC Works of M15 Grade 1: 2:4 </li><li>RCC Works of M 25 Grade for Column Footing, Plinth Beams, Columns, and Roof Slabs. The thickness of the roof slab shall be 5” thick</li><li>RCC Works of M 20 Grade for Lintel, Canopy Projections, Staircase</li><li>Column Sizes will be of 8”x18” min</li><li>Soil testing (SBC of 180kN/m2 at 5’ depth from EGL)</li><li>Water Proffing: Dr. Fixit</li><li>Roof to Roof Height be 11’0”</li><li>9” Bricks for External & 4.5” for Internal</li></ul>,
  className: "pdp-frame-168",
};
const frame19863Data = {
  id:"door-frames",
  text10: "Door Frames",
  text11: <ul><li>Main Door - Teak Wood Frame of size 5” x 4”</li><li>Pooja Door - Teak Wood Frame of Size 5”x 3”.</li><li>Internal Doors - All internal Doors are Teak Wood of size 5”x 21/2”</li><li>Bathroom Doors – Teak Wood of size 5”x 21/2”</li></ul>,
  className: "pdp-frame-168",
};
const frame19864Data = {
  id:"door-shutters",
  text10: "Door Shutters",
  text11: <ul><li>Main Door - 1 ½” thick Teak Wood Shutter.</li><li>Pooja Room Door - 1 ½” thick Teak Wood Shutters.</li><li>Internal Door- Teak Wood Doors of 1 ½” thick.</li><li>Bathroom Doors: Teak Wood Doors.</li></ul>,
  className: "pdp-frame-168",
};
const frame19865Data = {
  id:"door-fittings",
  text10: "Door Fittings",
  text11: <ul><li>Main door and Pooja door are installed with Brass fittings.</li><li>Internal doors are installed with SS Fittings.</li></ul>,
  className: "pdp-frame-168",
};
const frame19866Data = {
  id:"window",
  text10: "Window",
  text11: <ul><li>Teak window i.e, 125sft of Window area for every 1000sqft of BUA</li><li>Window grill Rs.150/-Sft.</li></ul>,
  className: "pdp-frame-168",
};
const frame19867Data = {
  id:"flooring",
  text10: "Flooring",
  text11: <ul><li>Marble / Granite / Vitrified flooring of 300 Rs/sqft Inclusive of tax will be installed, for common areas (Kitchen, Dining, Living, Pooja Room & Internal staircase)</li><li>Vitrified/Granite flooring of 150 Rs/sqft Inclusive of tax will be installed, for all bedrooms.</li><li>Ceramic Tiles for Parking, balcony Flooring (Cost of Tile Rs. 60/Sqft).</li></ul>,
  className: "pdp-frame-168",
};
const frame19868Data = {
  id:"kitchen-counter",
  text10: "Kitchen Counter",
  text11: <ul><li>4’0” feet height Glazed tiles (Cost Rs.65/sqft) over 20mm thick Hassan Green granite platform one side with 18”x21” SS sink</li></ul>,
  className: "pdp-frame-168",
};
const frame19869Data = {
  id:"bathroom",
  text10: "Bathroom",
  text11: <ul><li>Anti-skid Ceramic Tile flooring for Toilets only (Cost of Tile Rs.70/Sqft- Inclusive of tax)</li><li>Dadoing Works - 10’ Height. Cost of Tile Rs.70/Sqft Inclusive of tax.</li><li>Bathroom Fittings - Rs 50,000 MRP for each Bathroom includes Wall mounted closet, Washbasin & CP fittings of Jaquar make.</li></ul>,
  className: "pdp-frame-168",
};
const frame19870Data = {
  id:"painting",
  text10: "Painting",
  text11: <ul><li>Internal Walls and Ceilings- Two coats Royal Emulsion of ASIAN PAINT for bedrooms over 1 coat of primer & 2 coats of putty.</li><li>External - Two coats of APEX of ASIAN Paints over 1 coat of external primer.</li></ul>,
  className: "pdp-frame-168",
};
const frame19871Data = {
  id:"switches-plates",
  text10: "Switches/Plates",
  text11: <ul><li>Anchor switches/Plates of Legrand Brand</li></ul>,
  className: "pdp-frame-168",
};


// Construction Luxury Content Ends//


// Interior Basic Content Starts//

const frame2086Data = {
  id:"kitchen",
  text10: "Kitchen",
  text11: <ul><li>Kitchen: Lower Unit: 27.5sqft x2ft(Depth) @1500rs/sqft</li><li>Kitchen: Loft: 20sqft x 2ft(Depth) @ 800rs/sqft</li><li>Kitchen: Overhead box- 6sqftx1ft depth @ 1000rs/sqft</li><li>Kitchen: Baskets-3nos inclusive of chanell’s. 2k/basket</li></ul>,
};
const frame20862Data = {
  id:"bedroom",
  text10: "Bedroom",
  text11: <ul><li>Wardrobes-42sqftx 2ft(Depth) @1250rs/sqft</li><li>Loft- 25sqft x 2ft(Depth) @ 650rs/sqft</li></ul>,
  className: "pdp-frame-168",
};
const frame20863Data = {
  id:"tv-unit",
  text10: "TV Unit",
  text11: <ul><li>7.5sqft x1ft depth at 1200rs/sqft</li></ul>,
  className: "pdp-frame-168",
};
const frame20864Data = {
  id:"specification",
  text10: "Specification",
  text11: <ul><li>VS ply Make- 18mm Thick, BWP Grade plywood for kitchen, where-ever applicable VS ply commercial Grade plywood for Hall other works ( Vs-ply 15Years replacement guarantee )</li><li>1 mm lamination's for Doors (1000.00 rs) & inside white lamination's 0.8mm</li><li>SS Handles & Accessories (For shutter, Loft, Kitchen SS Handles )</li><li>Europa Locks for Wardrobes</li><li>Laminated shutters with 2mm edge Banding all side</li><li>Hinges Ebco or Pegalar</li><li>Telescopic channels.</li></ul>,
  className: "pdp-frame-168",
};

// Interior Basic Content Ends//

// Interior Standard Content Starts//

const frame2087Data = {
  id:"kitchen",
  text10: "Kitchen",
  text11: <ul><li>Lower Unit: 27.5sqft x2ftdepth @1700rs/sqft</li><li>Loft: 20sqft x 2ft @ 800rs/sqft</li><li>Overhead box- 12sqftx1ft depth @ 1250rs/sqft</li><li>Baskets-6nos @ 2000rs/basket, inclusive of channels</li></ul>,
};
const frame20872Data = {
  id:"bedroom",
  text10: "Bedroom",
  text11: <ul><li>Wardrobes-56sqft @1350rs/sqft</li><li>Loft- 25sqft @ 800rs/sqft</li></ul>,
  className: "pdp-frame-168",
};
const frame20873Data = {
  id:"tv-unit",
  text10: "TV Unit",
  text11: <ul><li>15sqft x1ft depth at 1250rs/sqft</li></ul>,
  className: "pdp-frame-168",
};
const frame20874Data = {
  id:"pooja-unit",
  text10: "Pooja Unit",
  text11: <ul><li>4x1 @ 1ft depth at 1250rs/sqft</li></ul>,
  className: "pdp-frame-168",
};

const frame20875Data = {
  id:"specification",
  text10: "Specification",
  text11: <ul><li>VS ply Make- 19mm thick, BWP Grade plywood for kitchen, where-ever applicable VS ply commercial Grade plywood for Hall other works ( Vs-ply 15Years replacement guarantee )</li><li>1 mm lamination's for Doors (Merino, Ran Wood 1300.00 rs) & inside white lamination's 0.8mm</li><li>SS Handles & Accessories (For shutter, Loft, Kitchen SS Handles )</li><li>Europa Locks for Wardrobes</li><li>Laminated shutters with 2mm edge Banding all side</li><li>Hinges Ebco or Pegalar</li><li>Telescopic channels.</li></ul>,
  className: "pdp-frame-168",
};

// Interior Standard Content Ends//


// Interior Premium Content Starts//

const frame2088Data = {
  id:"kitchen",
  text10: "Kitchen",
  text11: <ul><li>Lower Unit: 55sqft x2ftdepth @1900rs/sqft</li><li>Loft: 30sqft x 2ft @ 1100rs/sqft</li><li>Overhead box- 18sqftx1ft depth @ 1100rs/sqft</li><li>Tandom Box-5000x5nos</li></ul>,
};
const frame20882Data = {
  id:"bedroom",
  text10: "Bedroom",
  text11: <ul><li>Wardrobes-63sqft @1500rs/sqft</li><li>Loft- 30sqft @ 900rs/sqft</li></ul>,
  className: "pdp-frame-168",
};
const frame20883Data = {
  id:"tv-unit",
  text10: "TV Unit",
  text11: <ul><li>130sqft x1ft depth at 1100rs/sqft</li></ul>,
  className: "pdp-frame-168",
};
const frame20884Data = {
  id:"pooja-unit",
  text10: "Pooja Unit",
  text11: <ul><li>5x2 @ 1ft depth at 1400rs/sqft</li></ul>,
  className: "pdp-frame-168",
};
const frame20885Data = {
  id:"crockery-unit",
  text10: "Crockery Unit",
  text11: <ul><li>4x7-28sqftx 2ft depth- at 1400/sqft</li></ul>,
  className: "pdp-frame-168",
};const frame20886Data = {
  id:"study-unit",
  text10: "Study Unit with Book Rack",
  text11: <ul><li>Table at 30sqft x2ft depth at 1400rs/sqft</li></ul>,
  className: "pdp-frame-168",
};const frame20887Data = {
  id:"false-ceiling",
  text10: "False Ceiling",
  text11: <ul><li>200sqft `@ Hall</li></ul>,
  className: "pdp-frame-168",
};
const frame20888Data = {
  id:"specification",
  text10: "Specification",
  text11: <ul><li>VS ply Make- 19mm thick, BWP Grade plywood for kitchen, where-ever applicable VS ply commercial Grade plywood for Hall other works ( Vs-ply 15Years replacement guarantee )</li><li>1 mm lamination's for Doors (Merino, Ran Wood 1300.00 rs) & inside white lamination's 0.8mm</li><li>SS Handles & Accessories (For shutter, Loft, Kitchen SS Handles )</li><li>Europa Locks for Wardrobes</li><li>Laminated shutters with 2mm edge Banding all side</li><li>Hinges Ebco or Pegalar</li><li>Telescopic channels.</li></ul>,
  className: "pdp-frame-168",
};

// Interior Premium Content Ends//

// Interior Luxury Content Starts//

const frame2089Data = {
  id:"kitchen",
  text10: "Kitchen",
  text11: <ul><li>Lower Unit: 70sqft x2ftdepth @ 2100rs/sqft</li><li>Loft: 40sqft x 2ft @ 1100rs/sqft</li><li>Overhead box- 25sqftx1ft depth @ 1500rs/sqft</li><li>Tandom Box-5000x 6nos</li></ul>,
};
const frame20892Data = {
  id:"bedroom",
  text10: "Bedroom",
  text11: <ul><li>Wardrobes-80sqft @1700rs/sqft</li><li>Loft- 40sqft @ 1000rs/sqft</li></ul>,
  className: "pdp-frame-168",
};
const frame20893Data = {
  id:"tv-unit",
  text10: "TV Unit",
  text11: <ul><li>40sqft x1ft depth at 1600rs/sqft</li></ul>,
  className: "pdp-frame-168",
};
const frame20894Data = {
  id:"pooja-unit",
  text10: "Pooja Unit",
  text11: <ul><li>7x3=21ft  @ 1ft depth at 1400rs/sqft</li></ul>,
  className: "pdp-frame-168",
};
const frame20895Data = {
  id:"crockery-unit",
  text10: "Crockery Unit",
  text11: <ul><li>4x7-28sqftx 2ft depth- at 1600/sqft</li></ul>,
  className: "pdp-frame-168",
};
const frame20896Data = {
  id:"study-unit",
  text10: "Study Unit with Book Rack",
  text11: <ul><li>Table at 40sqft x2ft depth at 1600rs/sqft</li></ul>,
  className: "pdp-frame-168",
};
const frame20897Data = {
  id:"false-ceiling",
  text10: "False Ceiling",
  text11: <ul><li>400sqft @ Living Room</li></ul>,
  className: "pdp-frame-168",
};const frame20898Data = {
  id:"shoe-rack",
  text10: "Shoe Rack",
  text11: <ul><li>@1500rs/sqft  4x3=12ft</li></ul>,
  className: "pdp-frame-168",
};
const frame20899Data = {
  id:"specification",
  text10: "Specification",
  text11: <ul><li>VS Gold or Archid Make-19mm thick, BWP Grade plywood for kitchen, where-ever applicable VS Gold or Archid commercial Grade plywood for Hall other works ( Vs-ply 15Years replacement guarantee )</li><li>1 mm Acrylic laminate for Kitchen, Internal 0.8mm Laminate for Kitchen. Wardrobes-4mm Veneer(80Rs/sqft inclusive of Spray polish) & Internal will be 0.8mm thickness)</li><li>SS Handles & Accessories (For shutter, Loft, Kitchen SS Handles )</li><li>Europa Locks for Wardrobes</li><li>Laminated shutters with 2mm edge Banding all side</li><li>Telescopic channels & Hinges Hettich or Hafle Make</li><li>Gyroc- Saint Gobian Make</li></ul>,
  className: "pdp-frame-168",
};

// Interior Luxury Content Ends//


const x12PackagesDetailPageTabletData = {
    packages: "Packages",
    rectangle76: "/Images/Packages/project-details-banner.png",
    basic: "Basic",
    number: "1600",
    rsSft: "Rs/Sft",
    place: "Standard",
    premium: "Premium",
    luxury: "Luxury",
    clarityDesignLine: "/Images/Packages/Icons/design-drowing.svg",
    designDrawings: "Design & Drawings",
    iconParkOutlineBuildingThree: "/Images/Packages/Icons/structure.svg",
    structure: "Structure",
    biDoorOpen: "/Images/Packages/Icons/door.svg",
    doorFrames: "Door Frames",
    mdiWindowShutter: "/Images/Packages/Icons/shutter.svg",
    doorShutters: "Door Shutters",
    iconParkOutlineDoorHandle: "/Images/Packages/Icons/door-fitting.svg",
    doorFittings: "Door Fittings",
    tablerWindow: "/Images/Packages/Icons/window.svg",
    window: "Window",
    icBaselineGridOn: "/Images/Packages/Icons/flooring.svg",
    frame: "/Images/Packages/Icons/Frame 1682.svg",
    frame1683: "/Images/Packages/Icons/Frame 1683.svg",
    frame1684: "/Images/Packages/Icons/Frame 1684.svg",
    frame1685: "/Images/Packages/Icons/Frame 1685.svg",
    bedRoom: "/Images/Packages/Icons/bed-room.svg",
    tv: "/Images/Packages/Icons/tv-unit.svg",
    poojaRoom: "/Images/Packages/Icons/pooja-room.svg",
    crockery: "/Images/Packages/Icons/crockery-unit.svg",
    study: "/Images/Packages/Icons/study-unit.svg",
    ceiling: "/Images/Packages/Icons/false-ceiling.svg",
    shoe: "/Images/Packages/Icons/shoe-rack.svg",
    flooring: "Flooring",
    kitchenCounter: "Kitchen Counter",
    bathroom: "Bathroom",
    painting:"Painting",
    switchesPlates: "Switches/Plates",
    kitchen: "Kitchen",
    bedroom: "Bedroom",
    tvUnit: "TV Unit:",
    poojaUnit: "Pooja Unit",
    crockeryUnit: "Crockery Unit",
    studyUnit: <>Study Unit with <br/> Book Rack</>,
    falseCeiling: "False Ceiling",
    shoeRack: "Shoe Rack",
    group102Props: group102Data,
    frame692Props: frame692Data,
    frame692Props2: frame6922Data,
    frame692Props3: frame6923Data,
    // Construction  Starts
    //Basic
    frame1686Props: frame1686Data,
    frame16862Props: frame16862Data,
    frame16863Props: frame16863Data,
    frame16864Props: frame16864Data,
    frame16865Props:frame16865Data,
    frame16866Props: frame16866Data,
    frame16867Props: frame16867Data,
    frame16868Props: frame16868Data,
    frame16869Props: frame16869Data,
    frame16870Props: frame16870Data,
    frame16871Props: frame16871Data,
    //Standard
    frame1786Props: frame1786Data,
    frame17862Props: frame17862Data,
    frame17863Props: frame17863Data,
    frame17864Props: frame17864Data,
    frame17865Props: frame17865Data,
    frame17866Props: frame17866Data,
    frame17867Props: frame17867Data,
    frame17868Props: frame17868Data,
    frame17869Props: frame17869Data,
    frame17870Props: frame17870Data,
    frame17871Props: frame17871Data,
    //Premium
    frame1886Props: frame1886Data,
    frame18862Props: frame18862Data,
    frame18863Props: frame18863Data,
    frame18864Props: frame18864Data,
    frame18865Props: frame18865Data,
    frame18866Props: frame18866Data,
    frame18867Props: frame18867Data,
    frame18868Props: frame18868Data,
    frame18869Props: frame18869Data,
    frame18870Props: frame18870Data,
    frame18871Props: frame18871Data,
    //Luxury
    frame1986Props: frame1986Data,
    frame19862Props: frame19862Data,
    frame19863Props: frame19863Data,
    frame19864Props: frame19864Data,
    frame19865Props: frame19865Data,
    frame19866Props: frame19866Data,
    frame19867Props: frame19867Data,
    frame19868Props: frame19868Data,
    frame19869Props: frame19869Data,
    frame19870Props: frame19870Data,
    frame19871Props: frame19871Data,
    // Construction  Ends 


    // Interior Starts
    // Basic
    frame2086Props: frame2086Data,
    frame20862Props: frame20862Data,
    frame20863Props: frame20863Data,
    frame20864Props: frame20864Data,
    // Standard
    frame2087Props: frame2087Data,
    frame20872Props: frame20872Data,
    frame20873Props: frame20873Data,
    frame20874Props: frame20874Data,
    frame20875Props: frame20875Data,
    // Premium
    frame2088Props: frame2088Data,
    frame20882Props: frame20882Data,
    frame20883Props: frame20883Data,
    frame20884Props: frame20884Data,
    frame20885Props: frame20885Data,
    frame20886Props: frame20886Data,
    frame20886Props: frame20886Data,
    frame20887Props: frame20887Data,
    frame20888Props: frame20888Data,
    // Luxury
    frame2089Props: frame2089Data,
    frame20892Props: frame20892Data,
    frame20893Props: frame20893Data,
    frame20894Props: frame20894Data,
    frame20895Props: frame20895Data,
    frame20896Props: frame20896Data,
    frame20897Props: frame20897Data,
    frame20898Props: frame20898Data,
    frame20899Props: frame20899Data,
};


